import { forwardRef, type Ref, type SVGProps } from "react";

function SvgScallopedDiamond(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} width="87" height="87" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_145_23792)">
        <path
          d="M34.585 4.69238C39.5086 -0.230993 47.4914 -0.230994 52.415 4.69238L53.4355 5.71289C56.175 8.45231 59.8905 9.99208 63.7646 9.99219H64.0254C70.9884 9.99229 76.6327 15.6366 76.6328 22.5996V22.8604C76.6329 26.7345 78.1727 30.45 80.9121 33.1895L81.9326 34.21C86.856 39.1336 86.856 47.1164 81.9326 52.04L80.9121 53.0605C78.1727 55.8 76.6329 59.5155 76.6328 63.3896V63.6504C76.6327 70.6134 70.9884 76.2577 64.0254 76.2578H63.7646C59.8905 76.2579 56.175 77.7977 53.4355 80.5371L52.415 81.5576C47.4914 86.481 39.5086 86.481 34.585 81.5576L33.5645 80.5371C30.825 77.7977 27.1095 76.2579 23.2354 76.2578H22.9746C16.0116 76.2577 10.3673 70.6134 10.3672 63.6504V63.3896C10.3671 59.5155 8.82731 55.8 6.08789 53.0605L5.06738 52.04C0.14401 47.1164 0.144007 39.1336 5.06738 34.21L6.08789 33.1895C8.82731 30.45 10.3671 26.7345 10.3672 22.8604V22.5996C10.3673 15.6366 16.0116 9.99228 22.9746 9.99219H23.2354C27.1095 9.99208 30.825 8.45231 33.5645 5.71289L34.585 4.69238Z"
          fill="url(#paint0_linear_145_23792)"
          stroke="#9ED79D"
          strokeWidth="2"
        />
        <path
          d="M23.7455 33.9901L42.4453 23.7045C42.7684 23.5268 43.1311 23.4336 43.4997 23.4336C43.8684 23.4336 44.2311 23.5268 44.5541 23.7045L63.2539 33.9901C63.522 34.1374 63.7561 34.3394 63.9413 34.5828C64.1265 34.8263 64.2585 35.1059 64.3289 35.4036C64.3993 35.7012 64.4065 36.0104 64.35 36.311C64.2935 36.6116 64.1746 36.897 64.001 37.1488L45.3 64.2629C45.0989 64.5544 44.8299 64.7926 44.5163 64.9572C44.2027 65.1218 43.8539 65.2078 43.4997 65.2078C43.1456 65.2078 42.7967 65.1218 42.4831 64.9572C42.1695 64.7926 41.9006 64.5544 41.6994 64.2629L22.9985 37.1499C22.8248 36.8981 22.7059 36.6127 22.6494 36.3121C22.593 36.0115 22.6001 35.7023 22.6705 35.4047C22.7409 35.107 22.873 34.8274 23.0581 34.5839C23.2433 34.3405 23.4775 34.1385 23.7455 33.9912V33.9901Z"
          fill="url(#paint1_linear_145_23792)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_145_23792"
          x1="24.0938"
          y1="1.28523e-08"
          x2="43.5"
          y2="86.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_145_23792"
          x1="29.5745"
          y1="28.6554"
          x2="43.4988"
          y2="65.2082"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#094534" />
          <stop offset="1" stopColor="#4D9863" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgScallopedDiamond);
export default ForwardRef;
